export default __webpack_public_path__ + "static/media/work-report.e28b1df5.png";